import { InjectionToken } from "@angular/core";

export interface LibConfig {
    api_url: string;
    signInUrl: string;
    refreshTokenUrl: string;
    apiHartmannUrl: string;
}

export const LibConfigService = new InjectionToken<LibConfig>('LibConfig');